/**
 * i18n init — react-i18next with browser language detection.
 *
 * Languages enabled now: en (default), uk, ru.
 * Pack lists es/de/fr/pt as "soon" — keep disabled until translations exist.
 *
 * Storage key 'dathent-lang' aligns with LangSwitch component.
 * Resources are STUBS — replace with real translations as screens are ported.
 */
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import en from './locales/en/common.json';
import uk from './locales/uk/common.json';
import ru from './locales/ru/common.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'en',
    supportedLngs: ['en', 'uk', 'ru'],
    ns: ['common'],
    defaultNS: 'common',
    resources: {
      en: { common: en },
      uk: { common: uk },
      ru: { common: ru },
    },
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'dathent-lang',
      caches: ['localStorage'],
    },
    returnNull: false,
  });

export default i18n;
